if (!customElements.get('b2h-support-guide')) {
  customElements.define('b2h-support-guide', class B2HSupportGuide extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('[data-support-form]');
      this.results = this.querySelector('[data-support-results]');
      this.submitButton = this.querySelector('[data-support-submit]');
      this.resetButton = this.querySelector('[data-support-reset]');
      this.started = false;
      if (!this.form || !this.results) return;

      for (const panel of this.resultPanels()) panel.hidden = true;
      this.results.hidden = true;
      this.submitButton?.removeAttribute('hidden');
      this.resetButton?.removeAttribute('hidden');
      this.classList.add('is-enhanced');
      this.form.addEventListener('change', (event) => this.onChange(event));
      this.form.addEventListener('submit', (event) => this.onSubmit(event));
      this.form.addEventListener('reset', () => this.onReset());
      this.results.addEventListener('click', (event) => this.onResultClick(event));
      this.emit('view');
    }

    emit(action, detail = {}) {
      this.dispatchEvent(new CustomEvent('b2h:support-guide', {
        bubbles: true,
        detail: { action, ...detail },
      }));
    }

    resultPanels() {
      return [...this.results.querySelectorAll('[data-support-outcome]')];
    }

    selectedValue(question) {
      return this.form.querySelector(`[data-support-question="${question}"]:checked`)?.value || '';
    }

    onChange(event) {
      const control = event.target.closest('[data-support-question]');
      if (!control || !this.form.contains(control)) return;

      if (!this.started) {
        this.started = true;
        this.emit('start');
      }

      this.emit('answer', {
        question: control.dataset.supportQuestion,
        answer: control.value,
      });
    }

    outcomeFor({ timing, knownContext, intention }) {
      if (intention === 'practical') return 'practical_support';
      if (intention !== 'remembrance') return 'acknowledge_now';
      if (timing === 'just_heard' || knownContext !== 'name_story_shared') return 'recipient_choice';
      return 'personalized_remembrance';
    }

    onSubmit(event) {
      event.preventDefault();
      if (!this.form.checkValidity()) {
        this.form.reportValidity();
        return;
      }

      const answers = {
        relationship: this.selectedValue('relationship'),
        timing: this.selectedValue('timing'),
        knownContext: this.selectedValue('known_context'),
        intention: this.selectedValue('intention'),
      };
      const outcome = this.outcomeFor(answers);

      for (const panel of this.resultPanels()) panel.hidden = panel.dataset.supportOutcome !== outcome;
      this.results.hidden = false;
      this.emit('complete', {
        relationship: answers.relationship,
        timing: answers.timing,
        known_context: answers.knownContext,
        intention: answers.intention,
        outcome_key: outcome,
      });
      this.emit('outcome_view', { outcome_key: outcome });
      this.results.querySelector(`[data-support-outcome="${outcome}"] [data-support-result-heading]`)
        ?.focus({ preventScroll: false });
    }

    onResultClick(event) {
      const link = event.target.closest('[data-support-action]');
      if (!link || !this.results.contains(link)) return;
      const panel = link.closest('[data-support-outcome]');
      this.emit(link.dataset.supportAction === 'primary' ? 'primary_click' : 'secondary_click', {
        outcome_key: panel?.dataset.supportOutcome,
        destination_path: link.dataset.supportDestination,
      });
    }

    onReset() {
      requestAnimationFrame(() => {
        for (const panel of this.resultPanels()) panel.hidden = true;
        this.results.hidden = true;
      });
    }
  });
}
